import { EventEmitter } from "@angular/core";
import { TypeModel } from "../../../shared/models/type.model";
import { ColumnModel } from "../../../shared/models/column.model";

export class TypeBuildData{
    module = {
        name: "Type",
        new_name: "stock/type",
        has_dot_menu: true,
        icon:'fa-ad',
        permission:'stock_type'
    }
    
    onReload: EventEmitter < boolean > = new EventEmitter<boolean>();//Forces Reload of codeblack table on emit.
    rowFunction = (row:TypeModel) => {//Generates Row for codeblack-table
        return TypeModel.getListRow(row);
    }
    
    columns:ColumnModel[] = [
        {
            title: "Id",
            prop: "id",
            flex_grow: 1,
            row_accessor: "id",
            class:""//force-flex force-flex-end
        },
        {
            title: "Title",
            prop: "title",
            flex_grow: 4,
            row_accessor: "title",
        }
    ];

    constructor(){
        for(let col of this.columns){
            col = new ColumnModel(col);
        }
    }

}